import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import makeStyles from "@mui/styles/makeStyles";
import { useEnvContext } from "context/EnvContext";
import { APP_ACP } from "core/consts";
import { isChecked } from "ds_legacy/components/CheckboxInputField";
import { TEXT_DARK_PRIMARY } from "ds_legacy/materials/colors";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { dp, important, space } from "ds_legacy/materials/metrics";
import { FONT_SIZE_14, FONT_SIZE_15 } from "ds_legacy/materials/typography";
import { CSSProperties } from "react";
import { FormElement } from "react-forms-state";

export type ToggleInputFieldProps = {
  elementName: string;
  isImportant?: boolean;
  label?: string;
  onBeforeChange?: (value: number) => any;
  onChange: (arg: boolean) => void;
  shouldDisableChange?: boolean;
  shouldHideIndent?: boolean;
  value?: boolean | null;
  wrapperStyle?: CSSProperties;
};

// fix focus outline
const commonButtonBase = {
  "& .MuiButtonBase-root": {
    outlineOffset: dp(-6),
  },
};

const useStyles = makeStyles({
  importantLabel: Object.assign(
    {
      color: TEXT_DARK_PRIMARY,
      fontSize: important(FONT_SIZE_15),
      fontWeight: "bold",
    },
    commonButtonBase,
  ),
  label: Object.assign(
    {
      color: TEXT_DARK_PRIMARY,
      fontSize: important(FONT_SIZE_14),
    },
    commonButtonBase,
  ),
  noIndentRoot: Object.assign(
    {
      marginLeft: 0,
    },
    commonButtonBase,
  ),
  root: Object.assign(
    {
      marginLeft: space(2),
    },
    commonButtonBase,
  ),
});

export function ToggleInputFieldPresenter({
  elementName,
  isImportant,
  label,
  onBeforeChange,
  onChange,
  shouldDisableChange,
  shouldHideIndent,
  value,
  wrapperStyle,
}: ToggleInputFieldProps) {
  const { app } = useEnvContext();
  const classes = useStyles();

  const onChangeHandler = (e: any, checked: any) => {
    if (shouldDisableChange) return;
    if (onChange && onBeforeChange) {
      onChange(onBeforeChange(checked));
    } else if (onChange) {
      onChange(checked);
    }
  };

  return (
    <HorizontalLayout padding="0px 0px 0px 3px" style={{ ...wrapperStyle }}>
      <FormControlLabel
        classes={{
          label: isImportant ? classes.importantLabel : classes.label,
          root: shouldHideIndent ? classes.noIndentRoot : classes.root,
        }}
        control={
          <Switch
            aria-label={label}
            checked={isChecked(value)}
            color={app === APP_ACP ? "default" : "primary"}
            disabled={shouldDisableChange}
            onChange={onChangeHandler}
          />
        }
        disabled={shouldDisableChange}
        label={label}
        name={elementName}
      />
    </HorizontalLayout>
  );
}

export default FormElement()(ToggleInputFieldPresenter);
